import { ReactNode, useState } from 'react';
import { View } from 'react-native';
import { Modal, TModalProps } from '@/common/components/Modal/Modal';
import { Stack } from '@/common/components/Stack/Stack';
import { styles } from './ModalMultiStep.styles';

export function ModalMultiStep({
  className,
  steps,
  onClose,
  preventKeyboardNavigation,
  ...modalProps
}: TModalMultiStepProps) {
  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    setCurrentStep((step) => (step > 0 ? step - 1 : 0));
  };

  return (
    <Modal
      {...modalProps}
      onClose={onClose}
      footer={({ close }) => (
        <Stack horizontal align="center" justify="between">
          <Stack horizontal gap="sm">
            {steps.map((_, idx) => (
              <View
                key={idx}
                className={styles.step({ active: currentStep === idx })}
              />
            ))}
          </Stack>
          <Stack horizontal gap="md">
            {steps[currentStep].actions?.({
              onBack: handleBack,
              onNext: handleNext,
              closeModal: close,
            })}
          </Stack>
        </Stack>
      )}
    >
      {steps[currentStep].content}
    </Modal>
  );
}

export interface TModalMultiStepProps
  extends Omit<TModalProps, 'footer' | 'children'> {
  className?: string;
  steps: {
    content: ReactNode;
    actions?: (methods: {
      onBack: () => void;
      onNext: () => void;
      closeModal: () => void;
    }) => ReactNode;
  }[];
  preventKeyboardNavigation?: boolean;
  onClose: () => void;
}
